export const CUSTOM_REPORT_NUMBER_OF_ROWS = 16;
export const CUSTOM_REPORT_ROW_SIZE = 45;
export const CUSTOM_REPORT_NUMBER_OF_COLUMNS = 36;
export const CUSTOM_REPORT_WIDTH = 1350;
